var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source2, exclude) => {
  var target = {};
  for (var prop in source2) __hasOwnProp.call(source2, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source2[prop]);
  if (source2 != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source2)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source2, prop) && (target[prop] = source2[prop]);
  return target;
};
import * as React2 from "react";
import PropTypes from "prop-types";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
import * as React from "react";
var MessageVariantContext = React.createContext("inbound");
var bubbleVariantStyles = {
    inbound: {
      backgroundColor: "colorBackground",
      alignSelf: "flex-start"
    },
    outbound: {
      backgroundColor: "colorBackgroundPrimaryWeakest",
      alignSelf: "flex-end"
    }
  },
  ChatBubble = React2.forwardRef((_a, ref) => {
    var _b = _a,
      {
        children,
        element = "CHAT_BUBBLE"
      } = _b,
      props = __objRest(_b, ["children", "element"]);
    let variant = React2.useContext(MessageVariantContext);
    return React2.createElement(Box, __spreadValues(__spreadValues({
      display: "inline-block",
      fontSize: "fontSize30",
      lineHeight: "lineHeight20",
      borderRadius: "borderRadius30",
      paddingY: "space30",
      paddingX: "space40",
      marginBottom: "space30",
      element,
      ref,
      variant
    }, bubbleVariantStyles[variant]), safelySpreadBoxProps(props)), children);
  });
ChatBubble.displayName = "ChatBubble";
ChatBubble.propTypes = {
  children: PropTypes.node,
  element: PropTypes.string
};
import * as React3 from "react";
import PropTypes2 from "prop-types";
import { Box as Box2, safelySpreadBoxProps as safelySpreadBoxProps2 } from "@twilio-paste/box";
var messageVariantStyles = {
    inbound: {
      marginRight: "space70"
    },
    outbound: {
      marginLeft: "space70"
    }
  },
  ChatMessage = React3.forwardRef((_a, ref) => {
    var _b = _a,
      {
        children,
        variant,
        element = "CHAT_MESSAGE"
      } = _b,
      props = __objRest(_b, ["children", "variant", "element"]);
    return React3.createElement(MessageVariantContext.Provider, {
      value: variant
    }, React3.createElement(Box2, __spreadValues(__spreadValues({
      role: "listitem",
      display: "flex",
      flexDirection: "column",
      ref,
      element,
      variant
    }, messageVariantStyles[variant]), safelySpreadBoxProps2(props)), children));
  });
ChatMessage.displayName = "ChatMessage";
ChatMessage.propTypes = {
  children: PropTypes2.node,
  variant: PropTypes2.oneOf(["inbound", "outbound"]).isRequired,
  element: PropTypes2.string
};
import * as React4 from "react";
import PropTypes3 from "prop-types";
import { Box as Box3, safelySpreadBoxProps as safelySpreadBoxProps3 } from "@twilio-paste/box";
var ChatMessageMeta = React4.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CHAT_MESSAGE_META"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  let variant = React4.useContext(MessageVariantContext);
  return React4.createElement(Box3, __spreadValues({
    ref,
    element,
    display: "flex",
    justifyContent: variant === "inbound" ? "flex-start" : "flex-end",
    textAlign: variant === "outbound" ? "right" : "left",
    alignItems: "center",
    variant,
    columnGap: "space40"
  }, safelySpreadBoxProps3(props)), children);
});
ChatMessageMeta.displayName = "ChatMessageMeta";
ChatMessageMeta.propTypes = {
  "aria-label": PropTypes3.string.isRequired,
  children: PropTypes3.node.isRequired,
  element: PropTypes3.string
};
import * as React5 from "react";
import PropTypes4 from "prop-types";
import { Box as Box4, safelySpreadBoxProps as safelySpreadBoxProps4 } from "@twilio-paste/box";
var ChatMessageMetaItem = React5.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CHAT_MESSAGE_META_ITEM"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  return React5.createElement(Box4, __spreadValues({
    ref,
    element,
    display: "flex",
    alignItems: "center",
    columnGap: "space30",
    color: "colorTextWeak",
    lineHeight: "lineHeight20",
    fontSize: "fontSize20"
  }, safelySpreadBoxProps4(props)), children);
});
ChatMessageMetaItem.displayName = "ChatMessageMetaItem";
ChatMessageMetaItem.propTypes = {
  children: PropTypes4.node.isRequired,
  element: PropTypes4.string
};
import * as React6 from "react";
import PropTypes5 from "prop-types";
import { Box as Box5, safelySpreadBoxProps as safelySpreadBoxProps5 } from "@twilio-paste/box";
var ChatLog = React6.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CHAT_LOG"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  return React6.createElement(Box5, __spreadValues({
    role: "log",
    padding: "space70",
    element,
    ref
  }, safelySpreadBoxProps5(props)), React6.createElement(Box5, {
    as: "div",
    role: "list",
    margin: "space0",
    padding: "space0",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    rowGap: "space80"
  }, children));
});
ChatLog.displayName = "ChatLog";
ChatLog.propTypes = {
  children: PropTypes5.node,
  element: PropTypes5.string
};
import * as React7 from "react";
import PropTypes6 from "prop-types";
import { Button } from "@twilio-paste/button";
import { Box as Box6, safelySpreadBoxProps as safelySpreadBoxProps6 } from "@twilio-paste/box";
import { ClearIcon } from "@twilio-paste/icons/esm/ClearIcon";
import { ScreenReaderOnly } from "@twilio-paste/screen-reader-only";
var closeButtonBackgroundStyles = {
    backgroundColor: "colorBackgroundBody",
    borderRadius: "borderRadiusCircle",
    width: "12px",
    height: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  ComposerAttachmentCard = React7.forwardRef((_a, ref) => {
    var _b = _a,
      {
        children,
        onDismiss,
        i18nDismissLabel = "Remove attachment",
        element = "COMPOSER_ATTACHMENT_CARD"
      } = _b,
      props = __objRest(_b, ["children", "onDismiss", "i18nDismissLabel", "element"]);
    return React7.createElement(Box6, __spreadProps(__spreadValues({}, safelySpreadBoxProps6(props)), {
      ref,
      padding: "space30",
      borderStyle: "solid",
      borderColor: "colorBorderWeaker",
      borderRadius: "borderRadius30",
      borderWidth: "borderWidth10",
      boxShadow: "shadowLow",
      position: "relative",
      display: "inline-block",
      width: "100%",
      element
    }), children, onDismiss && React7.createElement(Box6, __spreadValues({
      position: "absolute",
      top: "space0",
      right: "space0",
      transform: "translate(50%, -50%)"
    }, closeButtonBackgroundStyles), React7.createElement(Button, {
      element: `${element}_REMOVE_BUTTON`,
      variant: "secondary_icon",
      size: "icon",
      onClick: onDismiss
    }, React7.createElement(ClearIcon, {
      decorative: !0
    }), React7.createElement(ScreenReaderOnly, null, i18nDismissLabel))));
  });
ComposerAttachmentCard.displayName = "ComposerAttachmentCard";
ComposerAttachmentCard.propTypes = {
  children: PropTypes6.node.isRequired,
  element: PropTypes6.string,
  i18nDismissLabel: PropTypes6.string,
  onDismiss: PropTypes6.func
};
import * as React10 from "react";
import PropTypes8 from "prop-types";
import { MediaObject, MediaFigure, MediaBody } from "@twilio-paste/media-object";
import * as React9 from "react";
import PropTypes7 from "prop-types";
import * as React32 from "react";
import * as React8 from "react";
import * as React22 from "react";
import * as React42 from "react";
var __create = Object.create,
  __defProp2 = Object.defineProperty,
  __getOwnPropDesc = Object.getOwnPropertyDescriptor,
  __getOwnPropNames = Object.getOwnPropertyNames,
  __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp2 = Object.prototype.hasOwnProperty,
  __commonJS = (cb, mod) => function () {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
      exports: {}
    }).exports, mod), mod.exports;
  },
  __copyProps = (to, from, except, desc) => {
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp2.call(to, key) && key !== except && __defProp2(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
  },
  __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", {
    value: mod,
    enumerable: !0
  }) : target, mod)),
  require_tslib = __commonJS({
    "../../../node_modules/react-uid/node_modules/tslib/tslib.js"(exports, module) {
      var __extends2, __assign2, __rest2, __decorate2, __param2, __metadata2, __awaiter2, __generator2, __exportStar2, __values2, __read2, __spread2, __spreadArrays2, __await2, __asyncGenerator2, __asyncDelegator2, __asyncValues2, __makeTemplateObject2, __importStar2, __importDefault2, __classPrivateFieldGet2, __classPrivateFieldSet2, __createBinding2;
      (function (factory) {
        var root = typeof global == "object" ? global : typeof self == "object" ? self : typeof this == "object" ? this : {};
        typeof define == "function" && define.amd ? define("tslib", ["exports"], function (exports2) {
          factory(createExporter(root, createExporter(exports2)));
        }) : typeof module == "object" && typeof module.exports == "object" ? factory(createExporter(root, createExporter(module.exports))) : factory(createExporter(root));
        function createExporter(exports2, previous) {
          return exports2 !== root && (typeof Object.create == "function" ? Object.defineProperty(exports2, "__esModule", {
            value: !0
          }) : exports2.__esModule = !0), function (id, v) {
            return exports2[id] = previous ? previous(id, v) : v;
          };
        }
      })(function (exporter) {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) b.hasOwnProperty(p) && (d[p] = b[p]);
        };
        __extends2 = function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        }, __assign2 = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) Object.prototype.hasOwnProperty.call(s, p) && (t[p] = s[p]);
          }
          return t;
        }, __rest2 = function (s, e) {
          var t = {};
          for (var p in s) Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0 && (t[p] = s[p]);
          if (s != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]) && (t[p[i]] = s[p[i]]);
          return t;
        }, __decorate2 = function (decorators, target, key, desc) {
          var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
          if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) (d = decorators[i]) && (r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r);
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        }, __param2 = function (paramIndex, decorator) {
          return function (target, key) {
            decorator(target, key, paramIndex);
          };
        }, __metadata2 = function (metadataKey, metadataValue) {
          if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(metadataKey, metadataValue);
        }, __awaiter2 = function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator.throw(value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }, __generator2 = function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            throw: verb(1),
            return: verb(2)
          }, typeof Symbol == "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            for (; _;) try {
              if (f = 1, y && (t = op[0] & 2 ? y.return : op[0] ? y.throw || ((t = y.return) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              switch (y = 0, t && (op = [op[0] & 2, t.value]), op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  return _.label++, {
                    value: op[1],
                    done: !1
                  };
                case 5:
                  _.label++, y = op[1], op = [0];
                  continue;
                case 7:
                  op = _.ops.pop(), _.trys.pop();
                  continue;
                default:
                  if (t = _.trys, !(t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1], t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2], _.ops.push(op);
                    break;
                  }
                  t[2] && _.ops.pop(), _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e], y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: !0
            };
          }
        }, __createBinding2 = function (o, m, k, k2) {
          k2 === void 0 && (k2 = k), o[k2] = m[k];
        }, __exportStar2 = function (m, exports2) {
          for (var p in m) p !== "default" && !exports2.hasOwnProperty(p) && (exports2[p] = m[p]);
        }, __values2 = function (o) {
          var s = typeof Symbol == "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length == "number") return {
            next: function () {
              return o && i >= o.length && (o = void 0), {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, __read2 = function (o, n) {
          var m = typeof Symbol == "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            for (; (n === void 0 || n-- > 0) && !(r = i.next()).done;) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              r && !r.done && (m = i.return) && m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        }, __spread2 = function () {
          for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read2(arguments[i]));
          return ar;
        }, __spreadArrays2 = function () {
          for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
          for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
          return r;
        }, __await2 = function (v) {
          return this instanceof __await2 ? (this.v = v, this) : new __await2(v);
        }, __asyncGenerator2 = function (thisArg, _arguments, generator) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var g = generator.apply(thisArg, _arguments || []),
            i,
            q = [];
          return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
            return this;
          }, i;
          function verb(n) {
            g[n] && (i[n] = function (v) {
              return new Promise(function (a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            });
          }
          function resume(n, v) {
            try {
              step(g[n](v));
            } catch (e) {
              settle(q[0][3], e);
            }
          }
          function step(r) {
            r.value instanceof __await2 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
          }
          function fulfill(value) {
            resume("next", value);
          }
          function reject(value) {
            resume("throw", value);
          }
          function settle(f, v) {
            f(v), q.shift(), q.length && resume(q[0][0], q[0][1]);
          }
        }, __asyncDelegator2 = function (o) {
          var i, p;
          return i = {}, verb("next"), verb("throw", function (e) {
            throw e;
          }), verb("return"), i[Symbol.iterator] = function () {
            return this;
          }, i;
          function verb(n, f) {
            i[n] = o[n] ? function (v) {
              return (p = !p) ? {
                value: __await2(o[n](v)),
                done: n === "return"
              } : f ? f(v) : v;
            } : f;
          }
        }, __asyncValues2 = function (o) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var m = o[Symbol.asyncIterator],
            i;
          return m ? m.call(o) : (o = typeof __values2 == "function" ? __values2(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
            return this;
          }, i);
          function verb(n) {
            i[n] = o[n] && function (v) {
              return new Promise(function (resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
              });
            };
          }
          function settle(resolve, reject, d, v) {
            Promise.resolve(v).then(function (v2) {
              resolve({
                value: v2,
                done: d
              });
            }, reject);
          }
        }, __makeTemplateObject2 = function (cooked, raw) {
          return Object.defineProperty ? Object.defineProperty(cooked, "raw", {
            value: raw
          }) : cooked.raw = raw, cooked;
        }, __importStar2 = function (mod) {
          if (mod && mod.__esModule) return mod;
          var result = {};
          if (mod != null) for (var k in mod) Object.hasOwnProperty.call(mod, k) && (result[k] = mod[k]);
          return result.default = mod, result;
        }, __importDefault2 = function (mod) {
          return mod && mod.__esModule ? mod : {
            default: mod
          };
        }, __classPrivateFieldGet2 = function (receiver, privateMap) {
          if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
          return privateMap.get(receiver);
        }, __classPrivateFieldSet2 = function (receiver, privateMap, value) {
          if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
          return privateMap.set(receiver, value), value;
        }, exporter("__extends", __extends2), exporter("__assign", __assign2), exporter("__rest", __rest2), exporter("__decorate", __decorate2), exporter("__param", __param2), exporter("__metadata", __metadata2), exporter("__awaiter", __awaiter2), exporter("__generator", __generator2), exporter("__exportStar", __exportStar2), exporter("__createBinding", __createBinding2), exporter("__values", __values2), exporter("__read", __read2), exporter("__spread", __spread2), exporter("__spreadArrays", __spreadArrays2), exporter("__await", __await2), exporter("__asyncGenerator", __asyncGenerator2), exporter("__asyncDelegator", __asyncDelegator2), exporter("__asyncValues", __asyncValues2), exporter("__makeTemplateObject", __makeTemplateObject2), exporter("__importStar", __importStar2), exporter("__importDefault", __importDefault2), exporter("__classPrivateFieldGet", __classPrivateFieldGet2), exporter("__classPrivateFieldSet", __classPrivateFieldSet2);
      });
    }
  }),
  generateUID = function () {
    var counter2 = 1,
      map = new WeakMap(),
      uid2 = function (item, index) {
        return typeof item == "number" || typeof item == "string" ? index ? "idx-" + index : "val-" + item : map.has(item) ? "uid" + map.get(item) : (map.set(item, counter2++), uid2(item));
      };
    return uid2;
  },
  uid = generateUID(),
  createSource = function (prefix) {
    return prefix === void 0 && (prefix = ""), {
      value: 1,
      prefix,
      uid: generateUID()
    };
  },
  counter = createSource(),
  source = React8.createContext(createSource()),
  getId = function (source2) {
    return source2.value++;
  },
  getPrefix = function (source2) {
    return source2 ? source2.prefix : "";
  },
  import_tslib = __toESM(require_tslib(), 1),
  {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __exportStar,
    __createBinding,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet
  } = import_tslib.default,
  prefixId = function (id, prefix, name) {
    var uid2 = prefix + id;
    return String(name ? name(uid2) : uid2);
  },
  UID = function (_super) {
    __extends(UID2, _super);
    function UID2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      return _this.state = {
        quartz: _this.props.idSource || counter,
        prefix: getPrefix(_this.props.idSource),
        id: getId(_this.props.idSource || counter)
      }, _this.uid = function (item) {
        return prefixId(_this.state.id + "-" + _this.state.quartz.uid(item), _this.state.prefix, _this.props.name);
      }, _this;
    }
    return UID2.prototype.render = function () {
      var _a = this.props,
        children = _a.children,
        name = _a.name,
        _b = this.state,
        id = _b.id,
        prefix = _b.prefix;
      return children(prefixId(id, prefix, name), this.uid);
    }, UID2;
  }(React22.Component);
var generateUID2 = function (context) {
    var quartz = context || counter,
      prefix = getPrefix(quartz),
      id = getId(quartz),
      uid2 = prefix + id,
      gen = function (item) {
        return uid2 + quartz.uid(item);
      };
    return {
      uid: uid2,
      gen
    };
  },
  useUIDState = function () {
    return React42.useState(generateUID2(React42.useContext(source)));
  };
var useUIDSeed = function () {
  var gen = useUIDState()[0].gen;
  return gen;
};
import { isSpaceTokenProp, ResponsiveProp } from "@twilio-paste/style-props";
import { Box as Box7, safelySpreadBoxProps as safelySpreadBoxProps7 } from "@twilio-paste/box";
var __defProp3 = Object.defineProperty,
  __defProps2 = Object.defineProperties,
  __getOwnPropDescs2 = Object.getOwnPropertyDescriptors,
  __getOwnPropSymbols2 = Object.getOwnPropertySymbols,
  __hasOwnProp3 = Object.prototype.hasOwnProperty,
  __propIsEnum2 = Object.prototype.propertyIsEnumerable,
  __defNormalProp2 = (obj, key, value) => key in obj ? __defProp3(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues2 = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp3.call(b, prop) && __defNormalProp2(a, prop, b[prop]);
    if (__getOwnPropSymbols2) for (var prop of __getOwnPropSymbols2(b)) __propIsEnum2.call(b, prop) && __defNormalProp2(a, prop, b[prop]);
    return a;
  },
  __spreadProps2 = (a, b) => __defProps2(a, __getOwnPropDescs2(b)),
  __objRest2 = (source2, exclude) => {
    var target = {};
    for (var prop in source2) __hasOwnProp3.call(source2, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source2[prop]);
    if (source2 != null && __getOwnPropSymbols2) for (var prop of __getOwnPropSymbols2(source2)) exclude.indexOf(prop) < 0 && __propIsEnum2.call(source2, prop) && (target[prop] = source2[prop]);
    return target;
  },
  getStackDisplay = orientation => Array.isArray(orientation) ? orientation.map(value => value === "horizontal" ? "flex" : "block") : orientation === "horizontal" ? "flex" : "block",
  getStackStyles = orientation => ({
    display: getStackDisplay(orientation),
    alignItems: "center",
    flexWrap: "wrap"
  }),
  getStackChildMargins = (orientation, spacing) => {
    let styles = {};
    if (Array.isArray(orientation)) {
      let marginRight = [],
        marginBottom = [];
      orientation.forEach((value, i) => {
        marginRight[i] = value === "horizontal" ? spacing : "space0", marginBottom[i] = value === "horizontal" ? "space0" : spacing;
      }), styles = {
        marginRight,
        marginBottom
      };
    }
    return orientation === "horizontal" && (styles = {
      marginRight: spacing
    }), orientation === "vertical" && (styles = {
      marginBottom: spacing
    }), styles;
  },
  Stack = React9.forwardRef((_a, ref) => {
    var _b = _a,
      {
        children,
        orientation,
        spacing,
        element = "STACK"
      } = _b,
      props = __objRest2(_b, ["children", "orientation", "spacing", "element"]);
    let [childrenCount, validChildren] = React9.useMemo(() => {
        let filteredChildren = React9.Children.toArray(children).filter(child => React9.isValidElement(child) || typeof child == "string");
        return [filteredChildren.length, filteredChildren];
      }, [children]),
      stackStyles = React9.useMemo(() => getStackStyles(orientation), [orientation]),
      childMargins = React9.useMemo(() => getStackChildMargins(orientation, spacing), [orientation, spacing]),
      keySeed = useUIDSeed();
    return React9.createElement(Box7, __spreadProps2(__spreadValues2(__spreadValues2({
      element
    }, safelySpreadBoxProps7(props)), stackStyles), {
      ref
    }), validChildren.map((child, index) => React9.createElement(Box7, __spreadProps2(__spreadValues2({
      element: `${element}_CHILD`
    }, childrenCount !== index + 1 ? childMargins : null), {
      key: keySeed(`stack-${index}`)
    }), child)));
  });
Stack.displayName = "Stack";
Stack.propTypes = {
  orientation: ResponsiveProp(PropTypes7.oneOf(["horizontal", "vertical"])).isRequired,
  spacing: isSpaceTokenProp,
  element: PropTypes7.string
};
var ChatAttachment = React10.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CHAT_ATTACHMENT",
      attachmentIcon
    } = _b,
    props = __objRest(_b, ["children", "element", "attachmentIcon"]);
  return React10.createElement(MediaObject, __spreadProps(__spreadValues({}, props), {
    as: "div",
    ref,
    verticalAlign: "center",
    element
  }), React10.createElement(MediaFigure, {
    as: "div",
    spacing: "space30"
  }, attachmentIcon), React10.createElement(MediaBody, {
    as: "div",
    element: `${element}_BODY`
  }, React10.createElement(Stack, {
    orientation: "vertical",
    spacing: "space10"
  }, children)));
});
ChatAttachment.displayName = "ChatAttachment";
ChatAttachment.propTypes = {
  children: PropTypes8.node.isRequired,
  element: PropTypes8.string,
  attachmentIcon: PropTypes8.node.isRequired
};
import * as React11 from "react";
import PropTypes9 from "prop-types";
import { Anchor } from "@twilio-paste/anchor";
import { Truncate } from "@twilio-paste/truncate";
var ChatAttachmentLink = React11.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      href,
      element = "CHAT_ATTACHMENT_LINK"
    } = _b,
    props = __objRest(_b, ["children", "href", "element"]);
  return React11.createElement(Anchor, __spreadValues({
    href,
    ref,
    element
  }, props), React11.createElement(Truncate, {
    title: children
  }, children));
});
ChatAttachmentLink.displayName = "ChatAttachmentLink";
ChatAttachmentLink.propTypes = {
  children: PropTypes9.string.isRequired,
  element: PropTypes9.string
};
import * as React12 from "react";
import PropTypes10 from "prop-types";
import { Text, safelySpreadTextProps } from "@twilio-paste/text";
var ChatAttachmentDescription = React12.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CHAT_ATTACHMENT_DESCRIPTION"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  return React12.createElement(Text, __spreadProps(__spreadValues({}, safelySpreadTextProps(props)), {
    element,
    ref,
    as: "div",
    fontSize: "fontSize20",
    color: "colorTextWeak",
    lineHeight: "lineHeight10"
  }), children);
});
ChatAttachmentDescription.displayName = "ChatAttachmentDescription";
ChatAttachmentDescription.propTypes = {
  children: PropTypes10.string.isRequired,
  element: PropTypes10.string
};
import * as React13 from "react";
import PropTypes11 from "prop-types";
import { Box as Box8, safelySpreadBoxProps as safelySpreadBoxProps8 } from "@twilio-paste/box";
var ChatBookend = React13.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CHAT_BOOKEND"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  return React13.createElement(Box8, __spreadProps(__spreadValues({}, safelySpreadBoxProps8(props)), {
    as: "div",
    role: "listitem",
    color: "colorTextWeak",
    element,
    textAlign: "center",
    marginBottom: "space20",
    lineHeight: "lineHeight20",
    fontSize: "fontSize20",
    ref
  }), children);
});
ChatBookend.displayName = "ChatBookend";
ChatBookend.propTypes = {
  children: PropTypes11.node,
  element: PropTypes11.string
};
import * as React14 from "react";
import PropTypes12 from "prop-types";
import { Box as Box9, safelySpreadBoxProps as safelySpreadBoxProps9 } from "@twilio-paste/box";
var ChatBookendItem = React14.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CHAT_BOOKEND_ITEM"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  return React14.createElement(Box9, __spreadProps(__spreadValues({}, safelySpreadBoxProps9(props)), {
    as: "div",
    element,
    ref
  }), children);
});
ChatBookendItem.displayName = "ChatBookendItem";
ChatBookendItem.propTypes = {
  children: PropTypes12.node,
  element: PropTypes12.string
};
import * as React15 from "react";
import PropTypes13 from "prop-types";
import { Box as Box10, safelySpreadBoxProps as safelySpreadBoxProps10 } from "@twilio-paste/box";
var ChatEvent = React15.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "CHAT_EVENT"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  return React15.createElement(Box10, __spreadProps(__spreadValues({}, safelySpreadBoxProps10(props)), {
    as: "div",
    role: "listitem",
    color: "colorTextWeak",
    element,
    textAlign: "center",
    lineHeight: "lineHeight20",
    fontSize: "fontSize20",
    ref
  }), children);
});
ChatEvent.displayName = "ChatEvent";
ChatEvent.propTypes = {
  children: PropTypes13.node,
  element: PropTypes13.string
};
import * as React16 from "react";
import { Box as Box11 } from "@twilio-paste/box";
import { useTransition, animated, useReducedMotion } from "@twilio-paste/animation-library";
var AnimatedChat = animated(Box11),
  buildTransitionX = chat => chat.variant === "inbound" ? -100 : chat.variant === "outbound" ? 100 : 0,
  ChatLogger = _ref => {
    let {
      chats
    } = _ref;
    let transitions = useTransition(chats, {
        keys: chat => chat.id,
        from: chat => ({
          opacity: 0,
          x: buildTransitionX(chat)
        }),
        enter: {
          opacity: 1,
          x: 0
        },
        leave: chat => ({
          opacity: 0,
          x: buildTransitionX(chat)
        }),
        config: {
          mass: 1,
          tension: 150,
          friction: 20
        }
      }),
      animatedChats = useReducedMotion() ? chats.map(chat => React16.cloneElement(chat.content, {
        key: chat.id
      })) : transitions((styles, chat, _ref2) => {
        let {
          key
        } = _ref2;
        return React16.createElement(AnimatedChat, {
          as: "div",
          style: styles,
          key
        }, chat.content);
      });
    return React16.createElement(ChatLog, null, animatedChats);
  };
ChatLogger.displayName = "ChatLogger";
import * as React17 from "react";
var chatWithId = chat => __spreadProps(__spreadValues({}, chat), {
    id: chat.id || uid(chat.content)
  }),
  useChatLogger = function () {
    for (var _len = arguments.length, initialChats = new Array(_len), _key = 0; _key < _len; _key++) {
      initialChats[_key] = arguments[_key];
    }
    let parsedInitialChats = React17.useMemo(() => initialChats.map(chatWithId), [initialChats]),
      [chats, setChats] = React17.useState(parsedInitialChats),
      push = React17.useCallback(next => {
        setChats(prev => prev.concat(chatWithId(next)));
      }, [setChats]),
      pop = React17.useCallback(id => {
        setChats(prev => id ? prev.filter(chat => chat.id !== id) : prev.slice(0, -1));
      }, [setChats]);
    return {
      push,
      pop,
      chats
    };
  };
export { ChatAttachment, ChatAttachmentDescription, ChatAttachmentLink, ChatBookend, ChatBookendItem, ChatBubble, ChatEvent, ChatLog, ChatLogger, ChatMessage, ChatMessageMeta, ChatMessageMetaItem, ComposerAttachmentCard, useChatLogger };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */